
import * as React from "react";
import { connect } from "react-redux";
import { Steps } from "../presentational/Steps";

export interface StepsContainerProps { 
  steps: any;
  extraSteps: any;
  cssClass? : string;
}

const mapStateToProps = (state : any) => {
  return {
    steps : state.steps,
    extraSteps: state.extraSteps
  };
};

 class StepsWrapper extends React.Component<StepsContainerProps> {
  constructor(props : StepsContainerProps) {
    super(props);
  }

  render() {
    return <Steps 
      cssClass={this.props.cssClass}
      steps={this.props.steps.steps}
      extraSteps={this.props.extraSteps.steps}
      activeStepFormName={this.props.steps.activeStepFormName}></Steps>;
  }
}

export const StepsContainer = connect(mapStateToProps)(StepsWrapper);